module.exports = "/images/icon-onboarding-route.svg?40c024454c352b135e4a9c217d0d8b01";